import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { useGuardedNavigate } from '@hooks/useUnsavedChangesWarning';

export default function Href({
  href,
  children,
  disabled = false,
  external = false,
  style,
  className: extraClassName,
  title,
  'aria-label': ariaLabel,
}) {
  const navigate = useGuardedNavigate();
  const location = useLocation();

  const isActive = location.pathname === href;

  function onClick(event) {
    event.preventDefault();

    if (disabled) return;

    if (external) {
      window.open(href, '_blank');
    } else {
      navigate(href);
    }
  }

  const linkClassName = [isActive ? 'active-link' : '', extraClassName].filter(Boolean).join(' ') || undefined;

  return (
    <a
      aria-label={ariaLabel}
      href={href}
      className={linkClassName}
      style={style}
      onClick={onClick}
      title={title}
    >
      {children}
    </a>
  );
}

Href.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array,
  ]),
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  'aria-label': PropTypes.string,
};
